/** @jsxImportSource @emotion/react */
import { memo } from 'react';

const Padder = ({ as: Component = 'div', ...props }) => {
	return <Component css={(theme) => theme.createPadding({ theme })} {...props} />;
};

export default memo(Padder);
